export default "__VITE_ASSET__BLtchnVa__"